<template>
  <div
    class="tag-wrapper"
    @click="
      [(showTable = true), (clickedForPopUp = true), combineAndSort(call)]
    "
  >
    <!--    @mouseenter="[(showTable = true), combineAndSort(call)]"-->
    <span
      class=" label tag-scheduled-call table-tag-content"
      @mouseleave="
        clickedForPopUp ? '' : (showTable = false), (clickedForPopUp = false)
      "
      :class="checkCaStatus"
    >
      <!--           @click="fillterMain"-->
      <span
        v-if="SCTimer.hasOwnProperty(clientData.id)"
        class="fake-sand-clock blinking"
        ><i class="fas fa-hourglass-start"></i
      ></span>
      <span
        v-if="!SCTimer.hasOwnProperty(clientData.id)"
        :class="{
          // autoMissedCall: call[0] && call[0].auto_status_id === null, // TODO: REMOVED BY NEW LOGIC 21-01-21
          todayCalls: clientData.call_status === 3,
          missedCall: clientData.call_status === 2,
          upComingCall: clientData.call_status === 1,
          tagNameDesign:
            clientData.call_status !== 1 && clientData.call_status !== 2
        }"
        >SC</span
      >
      {{ formatDate(call[0].scheduled_on) }}
      <span v-if="call.length > 1" class="tag-na forNumOutOfName">{{
        call.length
      }}</span>
      <a @click.prevent="$emit('delete')"
        ><span v-if="showRemove" class="fas fa-times remove-tag-icon"></span></a
    ></span>
    <!--    <span-->
    <!--            class=" label tag-scheduled-call table-tag-content"-->
    <!--            :class="checkCaStatus"-->
    <!--    >-->
    <!--    <i class="fas fa-hourglass-start"></i>-->

    <!--    </span>-->
    <div v-if="showTable"  :class="{'tag-table pop-up-for-tags-full' : openScStats,'tag-table pop-up-for-tags': !openScStats}">
      <!--      @mouseleave="showTable = false"-->
      <!--      @mouseenter="showTable = true"-->
      <!--      @mouseleave="showTable = false"-->
      <div  :class="{'table-responsive':!showHistory,'table-responsive-with-history':showHistory}">
<!--        <div class="for-quest-answers"-->
<!--        :class="{'for-quest-answers-when-opend':dropIsOpened}"-->
<!--        >-->
<!--          &lt;!&ndash;          <div class="qs-warning">&ndash;&gt;-->
<!--          &lt;!&ndash;            <span class="haj">Fill All Questions</span>&ndash;&gt;-->
<!--          &lt;!&ndash;          </div>&ndash;&gt;-->

<!--          <div class="for-min-width" v-for="(id, idx) in questLog" :key="id.id">-->
<!--            <span-->
<!--              class="quest-line-bold"-->
<!--              :class="{ 'dep-qs-form-even': idx % 2 === 0}"-->

<!--            >-->
<!--              {{ id.question | truncate(20) }}-->
<!--            </span>-->

<!--            <div class="quest-inline">-->
<!--              <client-answer-for-dep-->
<!--                :quest-log-idx="idx === 9 || idx === 10 ? true:false"-->
<!--                :for-sc-tag="true"-->
<!--                :client="clientData"-->
<!--                :question-id="id.id"-->
<!--                :send-updated="sendUpdated"-->
<!--                @updatedFromScTag="$emit('updatedFromScTag')"-->
<!--                @openedManuUp= "dropdownOpend"-->
<!--              ></client-answer-for-dep>-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->
        <table class="table">
          <thead>
            <tr>
              <th>
                <span class="for-avg">{{
                  totalCountAvgForMissedScToTitle(call)
                }}</span>
              </th>


              <!--              <th class="t-header"></th>-->


              <th class="t-header"></th>
              <th class="t-header"></th>
              <th class="t-header"></th>
              <th class="t-header"></th>
              <th class="t-header"></th>
              <th
                  v-if="clientScTra"
                  class="t-header assigned-to"></th>
              <th class="t-header from-missed-to-now">
                {{ FromMissedToNow(call) }}
              </th>
              <th class="t-header for-last-call" v-if="call.length > 1">
                {{ formatDateLc(call[0].created_at) }}
              </th>
              <th class="t-header" v-if="call.length === 0"></th>
              <th class="t-header for-last-call" v-if="call.length === 1">
                {{ formatDateLc(call.created_at) }}
              </th>
<!--              <th class="t-header" v-if="openScStats"></th>-->
              <th v-if="openScStats"></th>
              <th
                class="t-header"
                v-if="
                  clientData.hasOwnProperty('na') && clientData.na.length > 0 && openScStats
                "
              ></th>
              <th class="t-header" v-if="openScStats">
                <span
                  class="forAvg"
                  v-if="
                    clientData.hasOwnProperty('scheduled_calls') &&
                      clientData.scheduled_calls.length > 1
                  "
                >
                  <!--                 avg: -->{{
                    getDiffByScAvg(clientData.scheduled_calls, "updated_at")
                  }}
                </span>
              </th>
              <th class="t-header" v-if="openScStats"></th>
              <th class="t-header" v-if="openScStats"></th>
              <th class="t-header">
                <i
                  class="fa fa-times"
                  aria-hidden="true"
                  @click="(showTable = false), (clickedForPopUp = false)"
                ></i>
              </th>
            </tr>


            <tr>
              <th class="t-header">
<!--                <span class="mark-span">-->
<!--                  <i class="fas fa-exclamation mark"></i-->
<!--                ></span>-->
              </th>
<!--              <th class="t-header">DAY</th>-->
              <th class="t-header">SCHEDULED ON</th>
              <th class="t-header">STATUS</th>
              <th class="t-header">COMM</th>
              <th class="t-header">PRIORITY</th>
              <th class="t-header">AGENT</th>
              <th     v-if="clientScTra"
                  class="t-header assigned-to">ASSIGNED_TO</th>
              <th class="t-header">
                DATE
              </th>
              <th class="t-header">TIME</th>

              <th class="t-header" v-if="openScStats">REG-SC</th>
              <th
                class="t-header"
                v-if="
                  clientData.hasOwnProperty('na') && clientData.na.length > 0 && openScStats
                "
              >
                NA-SC
              </th>
              <th class="t-header" v-if="openScStats">SC-SC</th>
<!--              <th class="t-header" v-if="openScStats">AUTO</th>-->
              <th class="t-header" v-if="openScStats">C2C</th>
              <th class="t-header" v-if="openScStats" ></th>

              <th class="t-header">
                <i
                  class="fa fa-times"
                  aria-hidden="true"
                  @click="(showTable = false), (clickedForPopUp = false)"
                ></i>
              </th>
            </tr>
          </thead>
          <tbody class="center-it">
            <tr v-for="(item, idx) in call" :key="idx">
              <td>
<!--                <i-->
<!--                  v-if="item.is_missed && missedAfterTag"-->
<!--                  class="fas fa-exclamation markInSide"-->
<!--                ></i>-->
                <span class="diff-miss-to-call">
                  {{ filterMissedAndNext(call, idx) }}
                </span>
              </td>



<!--              <td class="for-day-name">-->
<!--                <span v-if="item.updated_at">{{-->
<!--                  getWeekDayName(item.updated_at)-->
<!--                }}</span>-->
<!--              </td>-->




              <td>
                <b>{{ formatDate(item.scheduled_on) + ' -'}} {{  getWeekDayName(item.scheduled_on)}}</b>
              </td>
              <td>
                <span
                    class="comment-p"
                    v-if="item.ca_stat"
                    v-tooltip.bottom="{ content: item.ca_stat }"
                >
                  {{ item.ca_stat  }}
                </span>
              </td>
              <td>
                <div v-if="item.comment || item.is_auto === 1">
                  <span
                      class="comment-p"
                      v-tooltip.right="{ content: item.is_auto === 1 ? `Missed call in time - Auto moved by viki in ${getDiffByScOn(call[idx], call[idx + 1])} Ahead` : item.comment }"
                  >
                    {{  item.is_auto === 1 ? `Missed call in time - Auto moved by viki in ${getDiffByScOn(call[idx], call[idx + 1])} Ahead` :item.comment | truncate(25) }}
                  </span>
                </div>
              </td>
              <td>
                <span
                  class="comment-p"
                  v-if="item.priority"
                  v-tooltip.bottom="{ content: item.priority.title }"
                >
                  {{ item.priority.title | truncate(6) }}
                </span>
              </td>
              <td>
                <span v-if="item.user.full_name">{{
                    item.is_auto === 1 ? 'VIKI-AI' : item.user.full_name
                  }}</span>
              </td>
              <td
                v-if="clientScTra"
                  class="assigned-to">{{clientData.transfers && checkIfScBeenTransferred(item)?clientData.transfers[0].to_user.full_name:''}}</td>
              <td
                  :class="{
                  inBetweenSelectedCalDates: checkSelectedCalDates(item)
                }"
              >

                {{ formatDateTable(item.updated_at) }}
              </td>

              <td
                  class="for-hour"
                  :class="{
                  inBetweenSelectedCalDates: checkSelectedCalDates(item)
                }"
              >
                {{ item.updated_at | shortTime }}
              </td>
              <td v-if="openScStats">
                <span class="comment-p">
                  {{
                    getDiffByTimes(
                      clientData.created_at,
                      item.scheduled_on
                    ).toUpperCase()

                  }}
                </span>
              </td>
              <!--              check diff from na to sc-->
              <td
                v-if="
                  clientData.hasOwnProperty('na') && clientData.na.length > 0 && openScStats
                "
              >
                <span class="comment-p">
                  {{
                    getDiffByTimes(
                      clientData.na[clientData.na.length - 1].created_at,
                      item.scheduled_on
                    ).toUpperCase()
                  }}
                </span>
              </td>
              <td v-if="openScStats">
                <span class="comment-p ">
                  {{
                    getDiffBySc(call[idx], call[idx + 1]) === 0
                      ? ""
                      : getDiffBySc(call[idx], call[idx + 1])
                  }}
                </span>
              </td >
<!--              auto-->
<!--              <td v-if="openScStats">-->
<!--                <span class="auto-stat">-->
<!--                  &lt;!&ndash;                  {{ item.is_auto }}&ndash;&gt;-->
<!--                  <i v-if="item.is_auto === 1" class="fab fa-autoprefixer"></i>-->
<!--                </span>-->
<!--              </td>-->
              <td v-if="openScStats">
                <span
                  v-if="clientData.calls_log.length > 0"
                  :class="{ green: calledOnTimeC2c }"
                  >{{
                    CountAvgForMissedToC2c(
                      call,
                      clientData.calls_log[0].created_at
                    )
                  }}</span
                >
              </td>
              <td v-if="openScStats"></td>
              <td></td>

            </tr>
          </tbody>
        </table>
        <span class="for-history-btn">
          <button
            v-if="log.length > 0"
            @click="showHistory = !showHistory"
            class="history-btn"
          >
            {{ showHistory ? "Hide History" : "Show History" }}
          </button>
             <button
                 @click="openScStats = !openScStats"
                 class="statistic-btn"
             >
            {{ openScStats ? "Hide Statistic" : "Show Statistic" }}
          </button>
        </span>
        <div v-if="showHistory">
          <div class="table-history">
            <table class="table ">
              <thead>
                <tr>
<!--                  <th :class="{ 't-header': showHistory }">-->
<!--                    <span class="mark-span">-->
<!--                      <i class="fas fa-exclamation mark"></i-->
<!--                    ></span>-->
<!--                  </th>-->


                  <th :class="{ 't-header': showHistory }">DAY</th>






                  <th :class="{ 't-header': showHistory }">AUTO</th>
                  <th :class="{ 't-header': showHistory }">
                    SCHEDULED ON TIME
                  </th>
                  <th :class="{ 't-header': showHistory }">STATUS</th>
                  <th :class="{ 't-header': showHistory }">COMM</th>
                  <th :class="{ 't-header': showHistory }">PRIORITY</th>
                  <th :class="{ 't-header': showHistory }">AGENT</th>
                  <th :class="{ 't-header': showHistory }">DATE</th>
                  <th :class="{ 't-header': showHistory }">TIME</th>
                  <th :class="{ 't-header': showHistory }">
                    <i
                      class="fa fa-times"
                      aria-hidden="true"
                      @click="(showTable = false), (clickedForPopUp = false)"
                    ></i>
                  </th>
                </tr>
              </thead>
              <tbody class="center-it">
                <tr v-for="(item, idx) in log" :key="idx">
<!--                  <td>-->
<!--                    <span-->
<!--                      :class="{-->
<!--                        'is-missed-flag': item.is_missed,-->
<!--                        'is-not-missed-flag': !item.is_missed-->
<!--                      }"-->
<!--                      ><span v-if="item.is_missed">{{-->
<!--                        formatDate(item.scheduled_on)-->
<!--                      }}</span>-->
<!--                    </span>-->
<!--                  </td>-->


                  <td class="for-day-name">
                    <span v-if="item.updated_at">{{
                      getWeekDayName(item.updated_at)
                    }}</span>
                  </td>






                  <td>
                    <span>
                      <!--                      {{ item.is_auto }}-->
                      <i
                        v-if="item.is_auto === 1"
                        class="fab fa-autoprefixer"
                      ></i>
                    </span>
                  </td>
                  <td>
                    <b>{{ formatDateTable(item.scheduled_on) }}</b>
                    <b>{{ item.scheduled_on | shortTime }}</b>
                  </td>
                  <td >
                    <p
                        class="for-histoy-stat"
                        v-if="item.status !== null"
                        v-tooltip.bottom="{ content: item.status.type }"
                    >
                      {{ item.status.type | truncate(161) }}
                    </p>
                  </td>
                  <td>
                    <div v-if="item.comment">
                      <p class="comment-p"   v-tooltip.bottom="{ content: item.comment }">
                        {{ item.comment | truncate(8)}}
                      </p>
                    </div>
                  </td>
                  <td v-if="item.priority">
                    <b>{{ item.priority.title }}</b>
                  </td>
                  <td>
                    {{ item.user.full_name }}
                  </td>
                  <td class="for-hour">{{ item.updated_at | shortTime }}</td>
                  <td>{{ formatDateTable(item.updated_at) }}</td>
                  <td></td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <Tooltip
      v-if="false"
      :direction="'top'"
      :group="'tags'"
      :tooltip-selector="'schedule-tag'"
    />
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import moment from "moment";
import GetDateTitles from "../../../../../../mixins/tags/GetDateTitles";
import getDiffInTime from "../../../../../../mixins/util/getDiffInTime";
import Tooltip from "../../../../../../main/util.main/Tooltip.component";
import _ from "lodash";
import Util from "bootstrap/js/src/util";
import ClientAnswerForDep from "../../../../../../features/company.feature/sub_features.company/clients_table.sub_feature.company/components/questioner/ClientAnswerForDep.component";

export default {
  name: "scheduled-call",
  components: {
    Tooltip,
    // ClientAnswerForDep
  },
  mixins: [GetDateTitles, getDiffInTime],
  props: {
    call: {
      type: Array,
      required: true
    },
    clientData: {
      type: Object,
      required: true
    },
    showRemove: {
      type: Boolean,
      required: true
    },
    log: {
      type: Array,
      required: true
    },
    sendUpdated: {
      type: Boolean,
      default: () => false
    }
  },
  created() {
    window.addEventListener("click", this.closeEdit);
  },
  data() {
    return {
      showToolTip: false,
      showTable: false,
      showHistory: false,
      caArr: [],
      clickedForPopUp: false,
      avgSctoSc: "",
      diffMandN: null,
      missedAfterTag: false,
      calledOnTimeC2c: false,
      questLog: [
        {
          id: 1,
          question: "Occupation"
        },
        {
          id: 2,
          question: "What Signals?"
        },
        {
          id: 3,
          question: "Trading Time"
        },
        {
          id: 4,
          question: "Invested So Far"
        },
        {
          id: 5,
          question: "How Much Profit Expected?"
        },
        {
          id: 6,
          question: "Plan To Invest?"
        },
        {
          id: 7,
          question: "Amount Of Broker Or Names"
        },
        {
          id: 8,
          question: "Amount Of Signals?"
        },
        {
          id: 9,
          question: "Reason for trading"
        },
        {
          id: 10,
          question: "Originaly From"
        },
        {
          id: 11,
          question: "Age"
        }
      ],
      dropIsOpened: false,
      openScStats: false,
      clientScTra : false

      // noMissedCalls:false
    };
  },

  computed: {
    dynamicLeft() {
      let isLong = false;
      this.caArr.forEach(item => {
        if (item.comment !== null && item.comment.length > 60) {
          isLong = true;
        }
      });

      if (isLong) {
        return "tag-table-left";
      }
      return "tag-table pop-up-for-tags";
    },
    ...mapState("clients", [
      "salesPersonList",
      "generalQueryObject",
      "SCTimer"
    ]),

    checkCaStatus() {
      if (this.call.slice().reverse()[0].ended) {
        return "ca-ended";
      }
      if (
          !this.call.slice().reverse()[0].ended &&
          this.call.slice().reverse()[0].priority_id === 1
      ) {
        return "ca-hi-priority";
      }
      if (
          !this.call.slice().reverse()[0].ended &&
          this.call.slice().reverse()[0].priority_id === 2
      ) {
        return "ca-low-priority";
      }
      return false;
    }
  },
  watch: {},
  mounted() {
 this.call.map(c =>{
  if(c.user.role === 5 || c.user.role === 4 || c.user.role === 3 || c.user.role === 2 || c.user.role === 1 ){
    this.clientScTra = true
  }
})

    // console.log(this.call);
    // this.checkMissingCallTag(this.call);
    //
    // if (
    //   this.clientData.hasOwnProperty("scheduled_calls") &&
    //   this.clientData.scheduled_calls.length > 1
    // ) {
    //   console.log(this.clientData.calls_log.length > 0);
    // this.clientData.calls_log[0].created_at
    // }

    $('[data-toggle="tooltip"]').tooltip();
  },
  methods: {
    checkIfScBeenTransferred(c){
      if(c.user.role === 5 || c.user.role === 4 || c.user.role === 3 || c.user.role === 2 || c.user.role === 1 ){
        return true;
      }
    },
    dropdownOpend(switched){
if(switched){
  this.dropIsOpened = true;
}else {
  this.dropIsOpened = false;
}
    },
    FromMissedToNow(callArr) {
      let tempArr = [];
      if (callArr.length > 1) {
        callArr.find(a => {
          if (a.is_missed !== 0) {
            tempArr.push(a);
          }
        });
        if (tempArr.length > 0) {
          if (tempArr[0].scheduled_on) {
            let lastMissed = moment(tempArr[0].scheduled_on);
            let duration = moment.duration(moment().diff(lastMissed));
            duration = duration.humanize();

            if (duration.includes("an")) {
              duration = duration.replace("an", "1 ");
            }
            if (duration.includes("a y")) {
              duration = duration.replace("a ", "1 ");
            }
            if (duration.includes("a d")) {
              duration = duration.replace("a ", "1 ");
            }
            if (duration.includes("days")) {
              duration = duration.replace("days", "D");
            }
            if (duration.includes("a few seconds")) {
              duration = duration.replace(" seconds", " sec");
            }
            return " L.M.C : " + duration;
          }
        }
      }
    },
    CountAvgForMissedToC2c(callArr, c2c) {
      if (callArr.length > 1) {
        callArr.map((call, num) => {
          let curCall = callArr[num];
          let curC2c = c2c;
          if (curCall) {
            if (curCall.is_missed === 1) {
              if (curCall.hasOwnProperty("tag_id") && curCall.tag_id !== null) {
                let c2cTime = moment(curC2c);
                let missedCallTime = moment(curCall.scheduled_on);
                let diffInMin = c2cTime.diff(missedCallTime);
                if (diffInMin <= 30000) {
                  this.calledOnTimeC2c = true;
                  return c2cTime;
                }
              }
            }
          }
        });
        return this.formatDate(c2c);
      }
    },
    totalCountAvgForMissedScToTitle(callArr) {
      if (callArr.length > 1) {
        let afterFilter = [];
        callArr.map((call, num) => {
          let curCall = callArr[num];
          let prevCall = callArr[num + 1];
          if (prevCall) {
            if (prevCall.is_missed === 1) {
              let rec1 = new Date(prevCall.scheduled_on);
              let rec2 = new Date(curCall.updated_at);
              let duration = moment.duration(moment(rec2).diff(rec1));
              afterFilter.push(duration);
              // console.log(duration.humanize());
            }
          }
        });
        if (afterFilter.length > 1) {
          let allCallsDur = afterFilter.reduce((a, b) => a + b);
          allCallsDur = allCallsDur / afterFilter.length;
          allCallsDur = moment.duration(allCallsDur);
          let hours = allCallsDur.humanize();
          let str = null;
          if (hours.indexOf("minutes") > 2) {
            str = hours.substr(0, 4);
          } else if (hours.indexOf("hours") > 2) {
            str = hours.substr(0, 4);
          } else if (hours.indexOf("days") > 2) {
            str = hours.substr(0, 4);
          } else if (hours.indexOf("months") > -1) {
            str = hours.substr(0, 4);
          } else if (hours.indexOf("years") > 2) {
            str = hours.substr(0, 4);
          } else {
            str = hours.substr(0, 3);
          }
          // console.log(str);
          if (str.includes("h")) {
            this.uperOrLowerH = str.includes("h");
          }
          if (str.includes("mi")) {
            this.uperOrLowerMinuts = str.includes("mi");
          }
          if (str.includes("an")) {
            str = str.replace("n", "h");
          }
          if (str.includes("a")) {
            str = str.replace("a", "1");
          }
          if (str.includes("mo")) {
            str = str.replace("mo", "M");
          }
          return "AVG : " + str;
        }
        // console.log(allCallsDur.humanize());
      }
    },
    filterMissedAndNext(callArr, idx) {
      if (callArr.length > 1) {
        let curRec = callArr[idx];
        let prevRec = callArr[idx + 1];
        if (prevRec) {
          if (prevRec.is_missed === 1) {
            if (prevRec.hasOwnProperty("tag_id") && prevRec.tag_id !== null) {
              //missed after na so missed will appear only 5M
              if (prevRec.tag_id === 1) {
                let now = moment();
                let missedCallTime = moment(prevRec.scheduled_on);
                let diffInMin = now.diff(missedCallTime);
                if (diffInMin > 30000) {
                  const date1 = new Date(prevRec.scheduled_on);
                  const date2 = new Date(curRec.updated_at);
                  this.missedAfterTag = true;
                  return this.getDiffByTimes(date2, date1);
                }
                //missed after diff tag so missed will appear only 90Mnpm
              } else if (
                prevRec.is_auto === 0 &&
                (prevRec.tag_id === 3 ||
                  prevRec.tag_id === 6 ||
                  prevRec.tag_id === 14)
              ) {
                let now = moment();
                let missedCallTime = moment(prevRec.scheduled_on);
                let diffInMin = now.diff(missedCallTime);
                if (diffInMin > 5400000) {
                  const date1 = new Date(prevRec.scheduled_on);
                  const date2 = new Date(curRec.updated_at);
                  this.missedAfterTag = true;
                  return this.getDiffByTimes(date2, date1);
                }
              }
            } else {
              const date1 = new Date(prevRec.scheduled_on);
              const date2 = new Date(curRec.updated_at);
              this.missedAfterTag = true;
              return this.getDiffByTimes(date2, date1);
            }
          }
        }
      }
    },
    filterMissedForAvg(missedOnly) {
      return this.getDiffByMissedAvg(
        missedOnly.filter(a => {
          return a.is_missed;
        }),
        "updated_at"
      );
    },
    checkSelectedCalDates(scDit) {
      let scIn = moment(scDit.created_at);
      let start = moment(
        this.generalQueryObject.scheduled_call_to_from
      ).startOf("day");
      let to = moment(this.generalQueryObject.scheduled_call_to_to).endOf(
        "day"
      );
      return scIn.isBetween(start, to); //TODO: Added 05-02-20
    },

    closeEdit(e) {
      if (!this.$el.contains(e.target)) {
        this.showTable = false;
      }
    },
    findUser(id) {
      return this.salesPersonList.find(element => {
        return element.id === id;
      });
    },
    formatDateLc(date) {
      if (date === undefined) {
        return "";
      }
      let duration = moment.duration(moment().diff(date));

      duration = duration.humanize();

      if (duration.includes("an")) {
        duration = duration.replace("an", "1 ");
      }
      if (duration.includes("a y")) {
        duration = duration.replace("a ", "1 ");
      }
      if (duration.includes("a d")) {
        duration = duration.replace("a ", "1 ");
      }
      if (duration.includes("a few seconds")) {
        duration = duration.replace(" seconds", " sec");
      }

      return " L.C : " + duration;
    },
    // formatDateForMissed(date){
    //  let temp =  moment(String(date));
    //   temp = moment(temp).add(1, 'm');
    //   temp = temp.format("HH:mm DD/MM/YY");
    //   return temp;
    // },
    formatDate(date) {
      return moment(String(date)).format("HH:mm DD/MM/YY");
    },
    formatDateTable(date) {
      return moment(String(date)).format("DD/MM/YY ");
    },

    filterCaStatus(data) {
      // console.log({ca:data.filter(item=>item.status_id !== null)})
      return data.filter(item => item.status_id !== null);
    },

    filterAutoCaStatus(data) {
      // console.log({auto: data.filter(item=>item.auto_status_id !== 0 && item.status_id === null)})  // TODO: REMOVED BY NEW LOGIC 21-01-21
      return data.filter(
        item => item.auto_status_id !== 0 && item.status_id === null
      );
    },

    combineAndSort(callData) {
      //  console.log(callData)
      /// console.log(callData.find(item=>item.status !==null))
      /*        const qBn = this.queryObject;
                  const qGroup = {group_assigned:[4]};
                  const query = {...qBn,...qGroup};*/
      this.caArr = [];
      let reasons = null;
      for (let i = 0; i < callData.length; i++) {
        // console.log(i);
        if (callData[i].status !== null) {
          callData[i].ca_stat = callData[i].status.type;
          callData[i].auto_stat = "";
          reasons = callData[i].status.type;
          //console.log(callData[0])
          //return [callData[0]];
          // arr=[...arr,...callData[i]]
          this.caArr.push(callData[i]);
        }
        // if (callData[i].auto_status !== null) {
        //   /*            const prevStat = callData.filter(item => item.status !== null);
        //                 const o = prevStat.shift()
        //       console.log(prevStat)*/
        //   callData[i].ca_stat = reasons;
        //   callData[i].auto_stat = callData[i].auto_status.type;
        //   //   console.log(callData[0])
        //   // arr=[...arr,...callData[i]]
        //   this.caArr.push(callData[i]);
        // }
      }

      // console.log(this.caArr);
      //const data =
    }
  }
};
</script>

<style lang="scss" scoped>
$dynamicLeft: var(--popup-left);

.tag-wrapper {
  display: inline-flex;
  position: relative;
  text-align: center;
}

.tag-scheduled-call {
  background-color: #ffa400;
  /*font-size: 12px;*/
  /*color: white;*/
  /*padding: 3px;*/
  /*!*font-size: 11px;*!*/
  /*margin: 2px;*/
  /*font-weight: 500;*/
  /*line-height: 2;*/
  /*cursor: pointer;*/
}

image {
  margin-top: 13px;
}

.ca-ended {
  background-color: #fa8101;
  opacity: 0.4;
}

.ca-hi-priority {
  background-color: #ff6900;
  animation: flash 1s linear infinite;
}
@keyframes flash {
  0% {
    opacity: 3;
  }
  50% {
    opacity: 0.7;
  }
  100% {
    opacity: 3;
  }
}

.ca-low-priority {
  background-color: #c67c00;
  animation: flash 2s linear infinite;
}

@keyframes flash {
  0% {
    opacity: 3;
  }
  50% {
    opacity: 0.7;
  }
  100% {
    opacity: 3;
  }
}

.tag-table {
  /*top: 1px !important;*/
  /*z-index: 10001;*/
  bottom: 40px !important;
  right: -409px !important;
  border: 1px solid #c67c00;
  font-size: 12px;
  text-align: center;
/*  height: 319px;*/
  overflow-y: hidden;
  overflow-x: hidden;
  width: 1500px;
}
.tag-table .table {
  margin-bottom: unset !important;
  text-align: center;
}
.table {
  transform: scaleX(-1);
}
.tag-table-left {
  position: absolute;
  top: 24px;
  right: -800px;
  z-index: 10001;
  width: max-content;
  border-radius: 5px;
  background-color: #fff;
  border: solid 1px #e4e8ea;
  -webkit-box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
  -moz-box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
}

.comment-p {
  max-width: 310px;
  height: auto;
  word-break: break-all;
  white-space: normal;
  text-align: left !important;
}

.table-responsive {
  border-radius: 5px;
  height: 304px;
  overflow: auto;
  transform: scaleX(-1);
  overflow-x: hidden;
  z-index: 0 !important;

}
.table-responsive-with-history{
  border-radius: 5px;
  height: 304px;
  overflow: auto;
  transform: scaleX(-1);
  overflow-x: hidden;
  z-index: 0 !important;
}

.name-span-table {
  min-width: 200px;
}

.tag-time {
  font-size: 8pt;
}

.remove-tag-icon {
  /*color: white;*/
  /*cursor: pointer;*/
  /*margin-left: 5px;*/
  color: white;
  cursor: pointer;
  margin-left: 0px;
  position: absolute;
  left: 11px;
  font-size: 17px;
  padding-top: 3px;
  padding-bottom: 2px;
  padding-left: 6px;
  padding-right: 6px;
  //border: 1px solid black;
  border-radius: 5px;
  top: 5px;
  background: black;
}
.remove-tag-icon:hover {
  color: white;
  background: black;
}
/*.remove-tag-icon:hover {*/
/*  color: #f44336;*/
/*}*/

.table-history {
  height: auto;
  max-height: 250px;
  /*overflow-y: hidden;*/
  /*<!--margin-top: -12px;-->*/
  padding-bottom: 22px;
}
.history-btn:focus,
.history-btn:active,
.statistic-btn:focus,
.statistic-btn:active{
  outline: none !important;
}

.statistic-btn{
  min-width: 97px;
  font-family: Montserrat;
  height: 25px;
  background: #efefef;
  /*<!--position: relative;-->*/
  /*<!--top: 348px;-->*/
  /*<!--right: -435px;-->*/
  color: black;
  border: 0;
  padding: 5px;
  font-size: 12px;
  font-weight: 400;
  cursor: pointer;
  /*margin-left: 630px;*/
  margin-top: 3px;
  margin-bottom: 5px;
  line-height: 12px;
}
.history-btn {
  min-width: 97px;
  font-family: Montserrat;
  height: 25px;
  background: #efefef;
  /*<!--position: relative;-->*/
  /*<!--top: 348px;-->*/
  /*<!--right: -435px;-->*/
  color: black;
  border: 0;
  padding: 5px;
  font-size: 12px;
  font-weight: 400;
  cursor: pointer;
  /*margin-left: 630px;*/
  margin-top: 3px;
  margin-bottom: 5px;
  line-height: 12px;
  /*float: right;*/
  /*position: relative;*/
  /*left: 5px*/
  /*font-family: Montserrat;*/
  /*height: 25px;*/
  /*background: #44a2d2;*/
  /*color: white;*/
  /*border: 0;*/
  /*padding: 5px;*/
  /*font-size: 12px;*/
  /*cursor: pointer;*/
  /*margin-left: 10px;*/
  /*margin-top: 10px;*/
  /*margin-bottom: 5px;*/
  /*line-height: 12px;*/
}
.label {
  padding: 4px 2px 4px 2px;
  font-size: 12px;
}
.table-responsive table tr td .comment-p {
  text-align: center !important;
}
.table-responsive button {
  text-align: right !important;
  margin-right: 4px !important;
}
.table-responsive table tr {
  text-align: left !important;
}
.missedCall {
  /*border: 1px solid #fc6a03 !important;*/
  background: #b2560d !important;
  border-radius: 5px;
  padding: 4.3px;
  font-size: 11.5px !important;
  margin-left: 3px;

  /* margin-right: 3px; */
  //border: 1px solid white;
  /*margin-right: 3px;*/
}
.missedCall:hover {
  font-size: 12.2px !important;
}

.autoMissedCall {
  /*!*border: 1px solid #fc6a03 !important;*!*/
  /*background: #cc5801 !important;*/
  /*border-radius: 5px;*/
  /*padding: 2px;*/
  /*font-size: 11px !important;*/
  /*margin-right: 3px;*/
  /* border: 1px solid #fc6a03 !important; */
  background: #cc5801 !important;
  border-radius: 5px;
  padding: 4.3px;
  font-size: 11.5px !important;
  /* margin-right: 3px; */
  //border: 1px solid white;
  margin-left: 3px;
}
.autoMissedCall:hover {
  font-size: 12.2px !important;
}
.upComingCall {
  //border: 1px solid white !important;
  background: #ed7014 !important;
  border-radius: 5px;
  padding: 4.3px;
  font-size: 11.5px !important;
  margin-left: 3px;

  /*margin-right: 3px;*/
}
.upComingCall:hover {
  font-size: 12.2px !important;
}
.tagNameDesign {
  background: #ffa400 !important;
  font-size: 11.5px !important;
  padding: 4px !important;
}
.tagNameDesign:hover {
  font-size: 12.2px !important;
}
.forNumOutOfName {
  font-weight: 100;
}
.inBetweenSelectedCalDates {
  color: blue;
}
tbody tr:nth-of-type(odd) {
  background-color: #7a7a7a0d;
}
tbody tr:last-child {
  background-color: unset !important;
}
/*.table-history tr:last-child{*/
/*  background-color: lightgrey !important;*/
/*}*/

.t-header {
  position: sticky;
  top: 0;
  background-color: white !important;
}
.for-history-btn {
  padding-bottom: 0px;
  display: flex;
  transform: scaleX(-1);
  justify-content: space-between;
}
/* width */
/*::-webkit-scrollbar {
  width: 3px;
}

!* Handle *!
::-webkit-scrollbar-thumb {
  background: grey;
  border-radius: 10px;
}*/
th.t-header {
  z-index: 2;
}
td.for-day-name {
  text-align: center;
  text-transform: initial;
}
td.for-hour {
  text-align: center;
}
th.t-header {
  text-align: center;
}

.center-it tr td {
  text-align: center;
}
.comment-p:hover .tool-comment {
  visibility: visible;
}
.auto-stat:hover .tool-auto-stat {
  visibility: visible;
}
.comment-p:hover .tool-comment-left {
  visibility: visible;
}
.tool-comment-left {
  visibility: hidden;
  width: fit-content;
  font-size: 0.7vw;
  background-color: #555;
  color: #fff;
  text-align: center;
  border-radius: 6px;
  /*padding: 5px 0;*/
  right: 70px;
  position: absolute;
  z-index: 2;
}
.tool-comment {
  visibility: hidden;
  width: fit-content;
  font-size: 0.7vw;
  background-color: #555;
  color: #fff;
  text-align: center;
  border-radius: 6px;
  /*padding: 5px 0;*/
  position: absolute;
  z-index: 2;
  max-width: inherit;
}
.tool-auto-stat {
  visibility: hidden;
  width: fit-content;
  font-size: 0.7vw;
  background-color: #555;
  color: #fff;
  text-align: center;
  border-radius: 6px;
  /*padding: 5px 0;*/
  position: absolute;
  z-index: 2;
}

.fake-sand-clock {
  //border: 1px solid white;
  border-radius: 5px;
  padding: 3px 7px;
  margin-right: 5px;
  /*margin-left: -5px;*/
  /*margin-left: -5px;*/
}
.blinking {
  -webkit-animation: 2s blink ease-in-out infinite;
  -moz-animation: 2s blink ease-in-out infinite;
  -ms-animation: 2s blink ease-in-out infinite;
  -o-animation: 2s blink ease-in-out infinite;
  animation: 2s blink ease-in-out infinite;
  animation: 2s blink ease-in-out infinite;
}

@keyframes blink {
  from,
  to {
    opacity: 0.3;
  }

  50% {
    opacity: 1;
  }
}

@-moz-keyframes blink {
  from,
  to {
    opacity: 0.3;
  }

  50% {
    opacity: 1;
  }
}

@-webkit-keyframes blink {
  from,
  to {
    opacity: 0;
  }

  50% {
    opacity: 1;
  }
}

@-ms-keyframes blink {
  from,
  to {
    opacity: 0;
  }

  50% {
    opacity: 1;
  }
}

@-o-keyframes blink {
  from,
  to {
    opacity: 0;
  }

  50% {
    opacity: 1;
  }
}
.hideIt {
  visibility: hidden;
}
.fa-times {
  cursor: pointer;
}
.table-responsive::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  background-color: #f5f5f5;

}

.table-responsive::-webkit-scrollbar {
  width: 7px;
  background-color: #f5f5f5;
  /*display: none;*/

}

.table-responsive::-webkit-scrollbar-thumb {
  background-color: #7a7a7a;
  border: 2px solid #555555;
  border-radius: 5px;
}
i.fa.fa-times {
  position: absolute;
  top: 12px;
  z-index: 5;
  right: 10px;
}

.is-missed-flag {
  color: red;
  font-size: 12px;
  font-weight: bold;
}
.is-not-missed-flag {
  color: green;
  font-weight: bold;
  background-color: rgba(27, 197, 27, 0.09) !important;
}
.forAvg {
  font-size: 11px;
  /*position: relative;*/
  /*top: 9px;*/
  /*z-index: 1;*/
}
.pop-up-for-tags-full {
  max-width: 1915px;
  position: absolute;
 /* top: -363px;*/
  background-color: white;
/*  height: 304px;*/
}
.pop-up-for-tags {
  max-width: 1066px;
  position: absolute;
  top: -363px;
  background-color: white;
}
.for-last-call {
  color: #00a700;
  font-weight: 800;
}
th.t-header.for-last-call {
  font-size: 10px;
}
span.diff-miss-to-call {
  font-size: 11px;
  color: red;
}
.mark {
  color: red;
  position: relative;
  left: 14px;
}
span.mark-span {
  position: relative;
  right: 14px;
}
.for-avg {
  color: red;
  padding-right: 3px;
  font-size: 10px;
}
.markInSide {
  color: red;
}
/*.missed{
  background-color: #f4511e;
}
.pre-missed{
  background-color: #ffa400;
}*/
.green {
  color: green;
}
.for-quest-answers {
  transform: scaleX(-1);
  display: flex;
  padding-bottom: 38px;
}
.for-quest-answers-when-opend{
  transform: scaleX(-1);
  display: flex;
  padding-bottom: 193px;
}
.quest-inline {
  cursor: pointer;
  padding-bottom: 26px;
  text-align: center;
  font-size: 12px;
  position: relative;
  top: 16px;
  padding: 5px;
  left: 14px;
}
.quest-line-bold{
  font-weight: bold;
}
.quest-line-bold.dep-qs-form-even {
  padding: 32px;
  font-weight: bold;
}
th.t-header.from-missed-to-now {
  color: #af3131;
  font-size: 10px;
}
.push-it-left{
  left: 20px !important;
}
.table-tag-content{
  padding: 3px 0 !important;
}
.for-histoy-stat{
  max-width: 310px;
  height: auto;
  word-break: break-all;
  text-align: center !important;
  white-space: normal;
  //text-align: left !important;
}
</style>
